import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function AboutUs() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    getAbout();

    const interval = setInterval(() => {
      getAbout();
    }, 5000); // refresh every 5 sec

    return () => clearInterval(interval);
  }, []);

  const getAbout = () => {
    fetch(`${BASE_URL}/api/getAbout.php`, {
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => setAbout(data))
      .catch((err) => console.error("Error:", err));
  };
  const [team, setTeam] = useState([]);

  useEffect(() => {
    getTeam();

    const interval = setInterval(() => {
      getTeam();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const getTeam = () => {
    fetch(`${BASE_URL}/api/getTeam.php?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => setTeam(data))
      .catch((err) => console.error("Error:", err));
  };

  const [activePlan, setActivePlan] = useState("bachat");

  return (
    <div className="about-page">
      <div className="about-hero">
        {/* LEFT: Static Home Page Content */}

        <div className="about-text">
          <div className="trust-header1">
            <span className="trust-tag1">About US</span>

            <h2>અમારા વિશે</h2>
          </div>
          {/* <div className="membership-title">
            <h2>અમારા વિશે</h2>
          </div> */}

          <h4>સંસ્થાનો પરિચય</h4>
          <p>
            શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લિ. એ માત્ર એક નાણાકીય સંસ્થા નથી, પરંતુ મહિલાઓના આર્થિક
            સશક્તિકરણનું એક માધ્યમ છે. અમારી સંસ્થાનો મુખ્ય ઉદ્દેશ્ય મહિલાઓમાં
            બચતની વૃત્તિ કેળવવી અને તેમને આર્થિક રીતે પગભર થવા માટે સરળ ધિરાણ
            પૂરું પાડવાનો છે. સહકાર અને વિશ્વાસના પાયા પર બનેલી આ સોસાયટી
            વર્ષોથી મહિલાઓના ઉત્થાન માટે કાર્યરત છે.
          </p>

          <h4>મુખ્‍ય ઉદ્દેશ્યો </h4>
          <ul>
            <li>મહિલાઓને બચત અને રોકાણ માટે પ્રોત્સાહિત કરવી.</li>
            <li>જરૂરિયાતમંદ મહિલાઓને ઓછા વ્યાજદરે લોન અને ધિરાણ આપવું.</li>
            <li>
              મહિલા ઉદ્યોગ સાહસિકોને વ્યવસાય શરૂ કરવા માટે આર્થિક મદદ કરવી.
            </li>
            <li>સભાસદોના આર્થિક અને સામાજિક હિતોનું રક્ષણ કરવું.</li>
          </ul>
        </div>

        {/* RIGHT: Dynamic About Image */}

        <div className="about-image">
          <img
            src={
              about?.image
                ? `${BASE_URL}/uploads/${about.image}`
                : "images/2.jpeg"
            }
            alt="about"
          />
        </div>
      </div>

      {/* HISTORY & FOUNDATION */}
      <div className="later-topics">
        <div>
          <h2>સંસ્થાનો ઇતિહાસ અને સ્થાપના</h2>
          <h4>"સહકારથી સમૃદ્ધિ તરફ – ૧૯૯૯ થી કાર્યરત"</h4>
          <p>
            શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લિ. ની સ્થાપના વર્ષ ૧૯૯૯ માં કરવામાં આવી હતી. છેલ્લા એક દાયકાથી પણ
            વધુ સમયથી અમારી સંસ્થા મહિલાઓને આર્થિક રીતે સક્ષમ અને આત્મનિર્ભર
            બનાવવાના મિશન સાથે કાર્ય કરી રહી છે.
          </p>
          <p>
            શરૂઆતમાં એક નાનકડા હેતુ સાથે સ્થપાયેલી આ સોસાયટી આજે હજારો મહિલા
            સભાસદોનો વિશ્વાસ જીતી ચૂકી છે. ૧૯૯૯ થી અત્યાર સુધીની અમારી સફર
            પારદર્શિતા, સુરક્ષા અને મહિલા ઉત્થાનના મજબૂત પાયા પર ટકેલી છે.
          </p>
        </div>
        <div>
          <h2>અમારો અનુભવ અને સિદ્ધિઓ</h2>
          <ul>
            <li>
              <strong>૨૮ વર્ષનો અનુભવ:</strong> ૧૯૯૯ થી સતત બેંકિંગ અને ધિરાણ
              ક્ષેત્રે બહેનોને શ્રેષ્ઠ સેવા પૂરી પાડી રહ્યા છીએ.
            </li>
            <li>
              <strong>વિશ્વાસનું પ્રતીક</strong>: સ્થાપના કાળથી જ અમે સભાસદોની
              મૂડીની સુરક્ષા અને યોગ્ય વળતરને પ્રાધાન્ય આપ્યું છે.
            </li>
            <li>
              <strong>મહિલા સશક્તિકરણ:</strong> છેલ્લા 28 વર્ષમાં અનેક મહિલાઓને
              પોતાનો નાનો વ્યવસાય શરૂ કરવા માટે આર્થિક ટેકો પૂરો પાડ્યો છે.
            </li>
          </ul>
        </div>
      </div>

      {/* EXPERIENCE & MILESTONES, VISION & MISSION, GIFTS & APPRECIATION */}
      <div className="later-topics">
        {/* EXPERIENCE & MILESTONES */}

        {/* VISION & MISSION */}
        <div>
          <h2>વિઝન અને મિશન</h2>
          <ul>
            <li>
              <strong>મિશન:</strong> ૧૯૯૯ માં જે ઉદ્દેશ્ય સાથે શરૂઆત કરી હતી, તે
              મુજબ દરેક ગૃહિણી અને કામકાજી મહિલાને કરકસર અને બચત દ્વારા આર્થિક
              રીતે મજબૂત બનાવવી.
            </li>
            <li>
              <strong>વિઝન:</strong> ટેકનોલોજી અને સહકારના સમન્વયથી આગામી
              વર્ષોમાં રાજ્યની અગ્રણી મહિલા ક્રેડિટ સોસાયટી બનવું.
            </li>
          </ul>
        </div>

        {/* GIFTS & APPRECIATION */}
        <div>
          <h2>સભાસદોને પ્રોત્સાહક ભેટ</h2>
          <ul>
            <li>
              દિવાળી કે વાર્ષિક ભેટ: દર વર્ષે વાર્ષિક સભા દરમિયાન અથવા તહેવારોના
              સમયે સભાસદોને ઉપયોગી વસ્તુઓ ભેટ (Gifts) તરીકે આપવામાં આવે છે.
            </li>
            <li>
              શૈક્ષણિક પુરસ્કાર: સભાસદોના તેજસ્વી સંતાનોને શૈક્ષણિક પ્રોત્સાહન
              ઇનામો આપવામાં આવે છે.
            </li>
          </ul>
        </div>
      </div>

      {/* SERVICES */}
      {/* SERVICES */}
      <div className="plan-detail">
        <div className="membership-title">
          <h2 style={{ marginBottom: "40px" }}>અમારી સેવાઓ</h2>
        </div>

        <div className="zigzag-wrapper">
          {/* ===================== BACHAT ===================== */}

          <div className="zigzag-row reverse">
            <div className="zigzag-image">
              {/* <img src="bachat-yojana-banner.png" alt="" /> */}
              <img src="images/bachat.webp" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Saving Plan</div>

              <h2>બચત યોજના</h2>

              <p>નિયમિત બચત કરીને ભવિષ્યને વધુ સુરક્ષિત અને મજબૂત બનાવો.</p>

              <div className="plan-grid">
                {/* BOX 1 */}
                <div className="plan-box">
                  <h2>બચત યોજના વિગત</h2>
                  <p>
                    ₹૧00/- કે ₹૧00/- ના ગુણાંક માં ગમે તેટલી રકમ માટે 1 વર્ષ ની
                    મુદત માટે ખાતું ખોલાવી શકાય છે.
                  </p>
                  <ul>
                    <li>
                      ₹૫00 /- નાં ૧૨ માસ મુજબ ₹૬૨૫0/- (સ્ટીલ ડબ્બી નંગ - ૧ )
                    </li>
                    <li>
                      ₹૧000/- નાં ૧૨ માસ મુજબ ₹૧૨૫00/- (સ્ટીલ ડબ્બો નંગ - ૧ )
                    </li>
                    <li>
                      ₹૨000/- નાં ૧૨ માસ મુજબ ₹૨૫000/- (સ્ટીલ બોઘરી નંગ - ૧ )
                    </li>
                    <li>
                      ₹૫000/- નાં ૧૨ માસ મુજબ ₹૬૨૫00/- (સ્ટીલ પુરી ડબ્બો /
                      નોનસ્ટીક તવો)
                    </li>
                  </ul>
                  <br></br>
                  <h2>અન્ય બચત યોજનાઓ</h2>
                  <p>બચત દ્વારા ભવિષ્ય સુરક્ષિત બનાવો.</p>
                  <ul>
                    <li>સામાન્ય બચત ૩.૫% વ્યાજ નો દર</li>
                    <li>ફરજીયાત બચત ૩.૫% વ્યાજ નો દર</li>
                    <li> ડેઇલી રીકરીંગ ૪.૫% વ્યાજ નો દર</li>
                  </ul>
                </div>

                {/* BOX 2 */}
              </div>
            </div>
          </div>

          {/* ===================== LOAN ===================== */}

          <div className="zigzag-row">
            <div className="zigzag-image">
              <img src="/images/fd2.png" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Fixed Deposit</div>

              <h2>ફિક્સ ડિપોઝિટ યોજના</h2>
              <div className="row">
                <div className="col-md-7 plan-box">
                  {" "}
                  <ul className="zigzag-list" style={{ paddingTop: "20px" }}>
                    <li>૧ વર્ષ માટે ૭.૫%</li>

                    <li>૨ વર્ષ માટે ૮.૫%</li>

                    <li>૩ વર્ષ માટે ૯.૫%</li>

                    <li>૮ વર્ષે બમણા</li>
                  </ul>
                </div>
                <div className="col-md-4 round" style={{ margin: "0px" }}>
                  <h4 className="text-center">
                    સીનીયર સીટીઝન (વડીલો) માટે 0.૫0% વધારે વ્યાજ
                  </h4>
                </div>
              </div>
              <ul className="zigzag-list">
                <h4 style={{ marginTop: "0px" }}>:: ૮ વર્ષે બમણા ::</h4>

                <li>₹૫,000 ની F.D. ઉપર સ્ટીલ નાનો ડબ્બો નંગ -૧</li>

                <li>₹૧0,000 ની F.D. ઉપર સ્ટીલ ડબ્બો નંગ -૧</li>

                <li>₹૨૫,000 ની F.D. ઉપર સ્ટીલ કાથરોટ નંગ -૧</li>

                <li>₹૫0,000 ની F.D. ઉપર સ્ટીલ પવાલી અથવા સ્ટીલ કઢાઈ નંગ -૧</li>
              </ul>
              <div className="zigzag-note">
                ₹૧૫,000/- કે તેથી વધુ રકમ ની ફિક્સ ડિપોઝિટ ત્રણ વર્ષ માટે મુકનાર
                ને ફ્રી ગીફ્ટ નો લાભ મળશે.
              </div>
            </div>
          </div>
          {/* ===================== INSURANCE ===================== */}

          <div className="zigzag-row reverse">
            <div className="zigzag-image">
              <img src="/images/vima.jpg" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Insurance Plan</div>

              <h2> વીમા યોજના</h2>

              <h5
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#5e6572",
                }}
              >
                તા. ૦૧/૦૧/૨૦૨૫ થી ₹૨,00,000/- ની વીમા યોજના સંપૂર્ણ પણે ચાલુ થઇ
                ગયેલ છે.
              </h5>
              <h5
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  color: "#5e6572",
                }}
              >
                વીમો કરાવનાર સભાસદ ને ફ્રી ગીફ્ટ નો લાભ મળશે.
              </h5>
              <ul className="zigzag-list">
                <li>
                  ૧૮ થી ૫૫ વર્ષ સુધીનાં સભાપદ વીમા યોજનામાં જોડાઈ શકશે, તેમજ
                  જ્યાં સુધી સભાસદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો મળવા પાત્ર
                  છે.
                </li>
                <li>
                  વીમા યોજના માં જોડાનાર સભાસદે પ્રથમવાર વીમો કરાવતી વખતે ફક્ત
                  એક વખતે ₹૫000/- વીમા યોજના ફી ભરવાની રહેશે.જે કોઈપણ સંજોગો માં
                  મળવાપાત્ર નથી.
                </li>

                <li>
                  વીમો થયા બાદ જે તે સભાસદ ના ખાતામાંથી સભાસદ દીઠ કોઈપણ સભાસદ
                  નું મૃત્યુ થાય તે સમયે જે રકમ મંડળી દ્વારા નક્કી કરવામાં આવે
                  તે તેના ફરજીયાત રકમ ના ખાતા માંથી ઉધારવામાં આવશે.
                </li>

                <li>
                  વર્ષ દરમિયાન ફરજીયાત બચતના ખાતામાંથી વીમા સહાય માટે જે રકમ
                  કપાયેલી હોઈ તે દર વર્ષે એપ્રિલ માસમાં ફરજીયાત બચતની સાથે જ
                  ફરજીયાત ભરવાની રહેશે.{" "}
                </li>

                <li>
                  વીમાદર સભાસદની બચત + વીમા પેટે કપાયેલી રકમ જમા કરાવવાની બાકી
                  હશે તો તે સભાસદ નો વીમો માન્ય ગણાશે નહી.
                </li>

                <li>
                  વીમો લેનાર સભાસદ તેમની હયાતીમાં જ વારસદારના નામ માં ફેરફાર કરી
                  શકશે. તેના માટે ₹૧00/- ફી ચુકવવાની રહેશે.
                </li>

                <li>
                  સદર વીમાયોજના નો લાભ સભાસદનું કોઈપણ રીતે મૃત્યુ થાય (આત્મહત્યા
                  સીવાય ) તો જ ₹૨,00,000/- નું વળતર મળવાપાત્ર છે.
                </li>

                <li>
                  સભાસદનું મૃત્યુ થયાના ૯0 દિવસ બાદ વિમાની રકમ વારસદાર ને ચૂકવવા
                  માં આવશે.
                </li>

                <li>
                  મૃત્યુ સમયે સભાસદ કે તેના નોંધાયેલા વારસદારો સદર સંસ્થાના
                  કોઈપણ પ્રકારના બાકીદારહશે કે સંસ્થાનું લેણું બાકી હશે તો
                  વળતરની રકમ માંથી બાકી લેણાંની રકમ કાપીને પછીની રકમ ચૂકવવા માં
                  આવશે.
                </li>

                <li>
                  કોઈપણ લોન લેનાર સભાસદમાં જામીન થયેલા હશો, તે બાબત ક્લિયર ના
                  થાય ત્યાં સુધી પાકતી વિમાની રકમ અટકાવવામાં આવશે.
                </li>

                <li>
                  વીમાદાર વ્યક્તિ જે લોન લેનાર સભાસદમાં જામીન થેલા હશે, જે
                  રેગ્યુલર સભાસદ હશે તો યોગ્ય બાબત વિચારી યોગ્ય કરવામાં આવશે.
                </li>
              </ul>
            </div>
          </div>
          <div className="zigzag-row">
            <div className="zigzag-image">
              <img src="images/loan.jpg" alt="" />
            </div>

            <div className="zigzag-content">
              <div className="zigzag-tag">Loan Facility</div>

              <h2>લોન સુવિધા</h2>

              <ul className="zigzag-list">
                <li>પ્રથમ લોન ₹૫0,000/- મળશે.</li>

                <li>હવે ૨0% બચત ની જગ્યાએ માત્ર 10% બચત જમા કરાવવી રહેશે.</li>

                <li>
                  ભાડુઆત સભાસદો માટે ત્રણેય જમીન મિલકતવાળા આપીને ક્રમશ:
                  ₹૫0,000/- થી ₹૭૫,000/- (રેગ્યુલર હપ્તા હોય તો ) સુધી લોન મળશે.
                </li>

                <li>
                  ટૂંક સમય માટે ૬0 વર્ષ સુધી ના સભાસદ વીમા સાથે લેવાનું ચાલુ
                  કરેલ છે.
                </li>
              </ul>

              <div className="row">
                <div className="col-md-7 box">
                  {" "}
                  <ul className="zigzag-list">
                    <h4>સોસાયટી નાં શેર સભાસદ બની નીચે મુજબ ના લાભ મેળવો. </h4>

                    <li>રોકડ જાતજામીન ધીરાણ : ₹૨,00,000/- (બે લાખ) સુધી.</li>

                    <li>
                      વિવિધ પ્રકારના સાધન ધિરાણ : ₹૧0,00,000/- (દસ લાખ) સુધી.
                    </li>

                    <li>મોર્ગેજ ધિરાણ : ₹૧૫,00,000/- (પંદર લાખ)સુધી.</li>
                  </ul>
                </div>
                <div className="col-md-4 box">
                  {" "}
                  <h4>
                    ૪ ના ગ્રુપ માં સભાસદ બની તુરંત જ ₹૫0,000/- રોકડ ધિરાણ મેળવો.
                  </h4>
                </div>
              </div>
              <div className="zigzag-note">
                લોન નિયમિત ભરનાર ને નિયમો અનુસાર વ્યાજ રિબેટ આપવામાં આવશે.
              </div>

              <h4> </h4>
            </div>
          </div>
        </div>
      </div>
      <div className="trust-section">
        <div className="trust-header">
          <span className="trust-tag">WHY CHOOSE US</span>

          <h2>અમને કેમ પસંદ કરશો?</h2>

          <p>
            વિશ્વાસ, સુરક્ષા અને પારદર્શક સેવાઓ સાથે મહિલાઓ માટે ખાસ બનાવેલ
            સહકારી સંસ્થા.
          </p>
        </div>

        <div className="modern-container">
          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-check-circle"></i>
            </div>
            <h4>પારદર્શક વહીવટ</h4>
            <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
            </div>
            <h4>મહિલા સંચાલિત</h4>
            <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-lightning"></i>
            </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
            <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h4>સરળ પ્રક્રિયા</h4>
            <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>
        </div>
      </div>

      {/* TEAM */}
      <div className="team-section">
        <h2>અમારી ટીમ</h2>

        <div className="team-container">
          {team.length > 0 ? (
            team.map((member, index) => (
              <div className="team-card" key={index}>
                <div className="team-image">
                  <img src={`${BASE_URL}/uploads/${member.photo}`} alt="" />
                </div>
                <div className="team-text">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No team members found</p>
          )}
        </div>
      </div>
    </div>
  );
}
